import { Component, Input } from '@angular/core';
import { AuthService } from '../../modules/authentication/services/auth.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
})
export class AppFooterComponent {
  @Input() internal = false;

  constructor(public cService: CommonService, public authService: AuthService) {}

  public toggleInfo(): void {
    (window as any).Optanon.ToggleInfoDisplay();
  }
}
